import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AMAZON_PRINT_URL, AMAZON_EBOOK_URL } from "@/data/constants";

export function useBookLinks() {
  const [links, setLinks] = useState({ print: AMAZON_PRINT_URL, ebook: AMAZON_EBOOK_URL });
  useEffect(() => {
    api.get("/foundation").then((r) => {
      const b = r.data || {};
      setLinks({ print: b.amazon_url || AMAZON_PRINT_URL, ebook: b.kindle_url || b.ebook_url || AMAZON_EBOOK_URL });
    }).catch(() => {});
  }, []);
  return links;
}
